import { motion } from "framer-motion";

const APP_IMG =
  "https://static.prod-images.emergentagent.com/jobs/04930588-728d-4dc0-a3d2-156f4b682011/images/fc85a40a03a8a7c95e25b9c3c52fa7740bcafc78883bdebf078ed909b02db4d0.jpeg";
const TABLE_IMG =
  "https://static.prod-images.emergentagent.com/jobs/04930588-728d-4dc0-a3d2-156f4b682011/images/97fe1f4f3434154444a8517fc0a98d1eeb010dd9247e68b097e73f33df582c59.jpeg";

const CHAPTERS = [
  {
    n: "01",
    en_title: "Automated scoring",
    it_title: "Punteggio automatico",
    en: "Omni tracks every rally and updates the score in real time. No pen, no paper, no arguments — the count is always right.",
    it: "Omni segue ogni scambio e aggiorna il punteggio in tempo reale. Niente carta, niente discussioni: il conteggio è sempre corretto.",
    img: APP_IMG,
    tall: true,
  },
  {
    n: "02",
    en_title: "Official ITTF rules",
    it_title: "Regole ITTF ufficiali",
    en: "Serves, lets, game and match points — every call is officiated to the letter of the ITTF rulebook.",
    it: "Servizi, let, palle gioco e match — ogni decisione segue alla lettera il regolamento ITTF.",
    img: TABLE_IMG,
    tall: false,
  },
  {
    n: "03",
    en_title: "Smarter matches",
    it_title: "Partite più intelligenti",
    en: "Match history, stats and camera-assisted calls turn every game into data you can learn from.",
    it: "Storico partite, statistiche e chiamate assistite dalla telecamera trasformano ogni gioco in dati da cui imparare.",
    img: null,
    tall: false,
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },
};

export const Manifesto = () => (
  <section
    data-testid="omni-manifesto"
    className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 py-24 sm:py-32"
  >
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
      variants={fadeUp}
      className="mb-16 sm:mb-24 max-w-2xl"
    >
      <span className="text-[0.7rem] font-bold uppercase tracking-[0.24em] text-[#f5a623]">
        How it works / Come funziona
      </span>
      <h2 className="font-display mt-5 text-4xl sm:text-5xl font-bold tracking-tight text-[#fafafa]">
        Three things Omni does,
        <span className="block text-[#8a8a92]">so you don't have to.</span>
      </h2>
    </motion.div>

    <div className="flex flex-col gap-14 sm:gap-20">
      {CHAPTERS.map((c, i) => (
        <motion.article
          key={c.n}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          data-testid={`manifesto-chapter-${c.n}`}
          className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-start ${
            i % 2 === 1 ? "md:[direction:rtl]" : ""
          }`}
        >
          <div className="md:col-span-6 [direction:ltr]">
            <div className="flex items-baseline gap-5">
              <span className="font-display text-5xl sm:text-6xl font-bold text-[#f5a623]/90 leading-none">
                {c.n}
              </span>
              <div className="h-px flex-1 bg-white/10 translate-y-[-0.4rem]" />
            </div>
            <h3 className="font-display mt-6 text-2xl sm:text-3xl font-semibold text-[#fafafa]">
              {c.en_title}
              <span className="block text-lg font-medium italic text-[#8a8a92]">
                {c.it_title}
              </span>
            </h3>
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#c9c9cf] max-w-md">
              {c.en}
              <span className="mt-2 block text-sm italic text-[#8a8a92]">
                {c.it}
              </span>
            </p>
          </div>

          {c.img && (
            <div className="md:col-span-6 [direction:ltr]">
              <div className="relative overflow-hidden rounded-sm border border-white/10">
                <div className="absolute inset-0 omni-spotlight opacity-60" />
                <img
                  src={c.img}
                  alt={c.en_title}
                  className={`relative w-full object-cover transition-transform duration-700 hover:scale-105 ${
                    c.tall ? "aspect-[3/4]" : "aspect-[4/3]"
                  }`}
                />
              </div>
            </div>
          )}
        </motion.article>
      ))}
    </div>
  </section>
);
